import SettingCtrl from './setting.controller';
import uirouter from 'angular-ui-router';
import senderSettings from './directives/sender-settings';
import userSettings from './directives/user-settings';
import developerSettings from './directives/developer-settings';
import adminSettings from './directives/admin-settings';
import settingsCustomFields from './directives/custom-fields';
import incomingSmsBuilder from './directives/incoming-sms-builder';
import createWebhookOverlay from './directives/create-webhook';
import createSitooCredentialsOverlay from './directives/create-sitoo-credentials';
import createUserOverlay from './directives/create-user';
import routing from './setting.routes';
import Setting from './setting.repository';
import SenderDetailsValidator from './services/senderDetailValidator';
import promoCodes from "./directives/promo-codes";
import uploadFile from "./directives/upload-file";
import notificationsSettings from "./directives/notifications-settings";
import NotificationType from "../notification/notification-type.repository";

export default angular.module('app.settings', [uirouter])
    .config(routing)
    .controller('SettingCtrl', SettingCtrl)
    .directive('senderSettings', () => new senderSettings)
    .directive('userSettings', () => new userSettings)
    .directive('developerSettings', () => new developerSettings)
    .directive('adminSettings', () => new adminSettings)
    .directive('settingsCustomFields', () => new settingsCustomFields)
    .directive('incomingSmsBuilder', () => new incomingSmsBuilder)
    .directive('createWebhookOverlay', () => new createWebhookOverlay)
    .directive('createSitooCredentialsOverlay', () => new createSitooCredentialsOverlay)
    .directive('createUserOverlay', () => new createUserOverlay)
    .component('uploadFile',  new uploadFile)
    .directive('promoCodes', () => new promoCodes)
    .directive('notificationsSettings', () => new notificationsSettings)
    .service('Setting', Setting)
    .service('NotificationType', NotificationType)
    .service('SenderDetailsValidator', SenderDetailsValidator)
    .name;
